import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import ModalityForm from '../components/forms/ModalityForm';
import '../styles/EmployeeMaster.css';
import ModalityTable from '../components/ModalityTable';
 
const ModalityEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route
 
  const [modalityData, setModalityData] = useState(null);
  const [loading, setLoading] = useState(false);
 
  // ✅ Show modal only if URL starts with /modality/edit
  const showModal = location.pathname.startsWith('/modality/edit');
 
  const handleCloseModal = () => {
    navigate('/modality'); // Go back to list
  };
 
  // ✅ Fetch Modality details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getModalityById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setModalityData(data.data);
          } else {
            setModalityData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching Modality by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);
 
  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Modality Master</h2>
      </div>
 
      {/* Table of Modalitys */}
      <ModalityTable />
 
      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Modality</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : modalityData ? (
            <ModalityForm modalityId={id} initialData={modalityData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this Modality.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
 
export default ModalityEditModel;